import { theme } from 'lib/style';
import { addThousandCommaSeparator } from 'lib/utils/functions';
import React from 'react';
import styled from 'styled-components/macro';
const Wrapper = styled.div`
  padding: 8px 0;
`;
const Row = styled.div`
  width: 80px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Label = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: ${theme.palette.gray60};
`;
const Number = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
type Props = {
  roiTotal: number;
  roiReq: number;
  roiOpt: number;
};
export const RoItems = ({ roiTotal, roiReq, roiOpt }: Props) => {
  return (
    <Wrapper>
      <Row>
        <Label>total:</Label>{' '}
        <Number>{addThousandCommaSeparator(roiTotal)}</Number>
      </Row>
      <Row>
        <Label>req.</Label> <Number>{addThousandCommaSeparator(roiReq)}</Number>
      </Row>
      <Row>
        <Label>opt.</Label> <Number>{addThousandCommaSeparator(roiOpt)}</Number>
      </Row>
    </Wrapper>
  );
};
